module.exports = __webpack_public_path__ + "static/img/200104.8bd37936.png";